(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('ts-fw-config').textContent);
  const root = config.root.replace(/\/?$/, '/');
  const forms = [...document.querySelectorAll('.ts-purchase')];
  let busy = false;
  const money = n => new Intl.NumberFormat(undefined, {style:'currency', currency:config.currency}).format(n / 100);
  async function request(path, options = {}) {
    const response = await fetch(root + path, {...options, credentials:'same-origin', cache:'no-store', headers:{'Accept':path.includes('view=') ? 'text/html' : 'application/json', 'Content-Type':'application/json'}});
    const body = await response.json();
    if (!response.ok) throw new Error(body.description || 'Unable to confirm availability. Please try again.');
    return body;
  }
  forms.forEach(form => {
    const select = form.querySelector('select');
    const button = form.querySelector('button');
    const status = form.querySelector('[role=status]');
    let uncertain = false;
    select.addEventListener('change', () => {
      if (uncertain) return;
      status.textContent = '';
      button.textContent = select.value ? 'Add to bag — ' + money(Number(select.selectedOptions[0].dataset.price)) : 'Select size';
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || uncertain) return;
      const id = Number(select.value);
      if (!id) {status.textContent = 'Choose an available size first.'; select.focus(); return;}
      const quotedPrice = Number(select.selectedOptions[0].dataset.price);
      busy = true;
      const disabled = forms.map(f => [...f.querySelectorAll('button,select')].map(el => [el, el.disabled]));
      disabled.flat().forEach(([el]) => {el.disabled = true;});
      status.textContent = 'Checking availability…';
      let attempted = false;
      try {
        const handle = encodeURIComponent(form.dataset.handle);
        const product = await request('products/' + handle + '.js?ts=' + Date.now());
        const inventory = await request('products/' + handle + '?view=rarely-waitlist-json&ts=' + Date.now());
        const variant = product.variants?.find(v => v.id === id);
        const stock = inventory.variants?.find(v => v.id === id);
        if (!variant?.available || !stock?.available) throw new Error('That size is no longer available. Please choose another size.');
        if (stock.preorder) throw new Error('This size is now on preorder. Please review delivery details on the product page before buying.');
        if (variant.price !== quotedPrice) {
          select.selectedOptions[0].dataset.price = String(variant.price);
          select.selectedOptions[0].textContent = variant.title + ' — ' + money(variant.price);
          throw new Error('The price changed to ' + money(variant.price) + '. Review it, then add again.');
        }
        const before = await request('cart.js');
        if (before.currency !== config.currency) throw new Error('Your currency changed. Reload this page before adding.');
        const quantity = cart => cart.items.filter(i => i.variant_id === id).reduce((sum,i) => sum+i.quantity,0);
        const previous = quantity(before);
        attempted = true;
        await request('cart/add.js', {method:'POST', body:JSON.stringify({items:[{id,quantity:1}]})});
        const after = await request('cart.js');
        if (quantity(after) !== previous + 1) throw new Error('Bag quantity could not be confirmed.');
        for (const item of before.items) {
          if (item.variant_id !== id && !after.items.some(i => i.key === item.key && i.quantity === item.quantity)) throw new Error('Please review your bag before continuing.');
        }
        status.textContent = 'Added to your bag. Choose another piece or view your bag.';
        const bag = document.querySelector('.ts-bag-status');
        bag.hidden = false; bag.textContent = 'View bag · ' + after.item_count + ' items · ' + money(after.total_price);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        status.textContent = attempted ? 'Your bag may have changed. View your bag before trying again. ' + error.message : error.message;
        if (attempted) {
          uncertain = true;
          const bag = document.querySelector('.ts-bag-status'); bag.hidden = false; bag.textContent = 'Review your bag';
        }
      } finally {
        disabled.flat().forEach(([el, wasDisabled]) => {el.disabled = wasDisabled;});
        if (uncertain) {button.disabled = true; button.textContent = 'Review your bag';}
        busy = false;
      }
    });
  });
})();
